<app-tabs>
  <app-countries-tab />
  <app-provinces-tab />
  <app-cities-tab />
</app-tabs>
